<template>
<div class="card" v-if="summary" :class="{ 'selected': summary.selected }">
  <div class="card-header">

    <!-- PRODUCT / INSURER -->
    <span :title="summary.insurer || ''" :id="'policyCard-'+translatedInsurer">{{ translatedInsurer }}</span>

    <!-- VALIDATIONS -->
    <span class="val-icon" :class="validationsIconClass">
      <i class="fa fa-exclamation" aria-hidden="true"></i>
    </span>

  </div>
  <div class="card-body">
    <div class="premium">

      <!-- PREMIUM -->
      {{ summary.totalNetPremium || '-' | currency }}

      <!-- PAYMENT TERM -->
      <small v-if="summary.totalNetPremium">/ {{ summary.paymentTerm | translate('term.short') }}</small>

    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['summary', 'insurers'],
  computed: {
    translatedInsurer() {
      let insurer = this.insurers.find(insurer => insurer.name === this.summary.insurer);
      return insurer ? insurer.description : '-';
    },
    validationsIconClass() {
      if (this.summary.validationLevel === 'ERROR') return 'bg-danger';
      else if (this.summary.validationLevel === 'WARN') return 'bg-warning';
      else if (this.summary.validationLevel === 'INFO') return 'bg-info';
      else if (this.summary.validationLevel === 'AUDIT') return 'bg-light text-dark';
      else return 'd-none';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/policy-card";

.card {
  cursor: default;
  + .card {
    margin-top: .75rem;
  }
}
.card-header {
  padding: .2rem 30px .2rem .5rem;
  font-size: 1rem;
}
.card-body {
  padding: .2rem .5rem;
}
.selected .card-body {
  border-color: $success;
}
.val-icon {
  right: 8px;
  bottom: -11px;
  width: 21px;
  height: 21px;
  font-size: 1rem;
}
.premium {
  padding: 0;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/case/PolicyCardMini.vue